module.exports = __webpack_public_path__ + "static/KYCComplete-e47f9c14c3464528bb666839bf069224.svg";